import {React, useState, useEffect} from "react";
import { useSelector } from "react-redux";
import { Header } from "../../components/common/Header.js";
import "./SearchPage.css";
import { useParams } from "react-router-dom";
import { SearchField } from "../../components/ReactAria/SearchField.js";
import { search_info } from "../../api/searchTool.js";
import { SideBar } from "../../features/SideBar/SideBar.js";
import { SearchResult } from "../../features/Search/SearchResult.js";


export const SearchPage = (props) => {
    const [searchQuery, setSearchQuery] = useState("");
    const [searchResult, setSearchResult] = useState([]);
    

    useEffect(() => {
        let timerId;
        async function runSearch() {
            try {
                const response = await search_info(searchQuery, "searchMulti");
                setSearchResult(response.results);   
            }catch(e){
                console.log("SEARCH ERROR: ", e)
            }
        }
        function debounceSearch() {
          clearTimeout(timerId); 
          timerId = setTimeout(runSearch, 600); 
        }
        debounceSearch();
        return () => clearTimeout(timerId);

    }, [searchQuery])

    return (
      <div className="search-page">
        <>
          <Header />
          <div className="search_page_wrapper">
            <div className="search_page_title">
              SEARCH FOR <br />
              WHAT YOU LOVE
            </div>
            <div className="search_page_search_box">
              <SearchField
                className="search_page"
                label="Search"
                onChange={setSearchQuery}
              />
              {searchResult.length > 0 && (
                <div className="search_page search_result">
                  <SearchResult searchData ={searchResult}/>
                </div>
              )}
            </div>
          </div>
        </>
        <SideBar />
      </div>
    );
}